import React from 'react'

const Logout = () => {
	return (
		<>
			<section className='gray-banner vh-75 d-flex align-items-center justify-content-center'>
				<div className="tsmc-loginbox">
					<div>
						<h1 className='fs-20 fw-700'>Your Successfully Logout</h1>
					</div>
				</div>
			</section>
		</>
	)
}

export default Logout
